export default __webpack_public_path__ + "static/media/mescom-logo.10d15e02.png";